import styles from './CancelButton.module.css';

function CancelButton({ onClick, disabled }) {
  return (
    <button
      className={styles.cancelButton}
      onClick={onClick}
      disabled={disabled}
    >
      Cancel
    </button>
  );
}
export default CancelButton;